import { clearAllLocalStorageItems } from '@utils/storage';

export const isTokenExpired = (error: string) =>
  error.includes('TOKEN_EXPIRED');

export const resetAndRedirectToLogin = () => clearAllLocalStorageItems();
